// extracted by mini-css-extract-plugin
export default {"popupIcons":"ChatPopupOptions_popupIcons__YraOp","icon":"ChatPopupOptions_icon__XXx-e"};